<template>
  <BaseDialog
    ref="dialog"
    contentClass="filters-dialog"
    sidePanel
    :show-actions="true"
    :persistent="false"
    :on-close="closeDialog"
    @closeModal="closeDialog"
    @dialog-closed="closeDialog"
  >
    <template slot="title">{{ title }}</template>
    <template slot="content">
      <slot />
    </template>
    <template slot="actions">
      <div class="filters-dialog__actions">
        <BaseButton isTransparent isUnderline isSquare :disabled="!hasActiveFilters" @click.native="$emit('clear-all')">
          {{ $t('filters.clear-all') }}
        </BaseButton>
        <BaseButton @click.native="closeDialog">{{ $t('filters.done') }}</BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';

// Every filter of a page, in a panel of its own (PhoneFilterBar). Filters apply as they change,
// so "Terminé" only closes it.
export default {
  name: 'FiltersDialog',
  components: { BaseButton, BaseDialog },
  props: {
    title: { type: String, required: true },
    hasActiveFilters: { type: Boolean, default: false },
  },
  methods: {
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
      this.$emit('close');
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.dialog.openModal());
  },
};
</script>

<style lang="scss">
.base-dialog__filters-dialog {
  width: min(420px, 100vw);
  max-width: 100%;

  .base-dialog__header {
    border-bottom: 1px solid $color-border;
  }

  .base-dialog__header + .base-dialog__content {
    background-color: $color-white;
    padding: 20px 24px;
  }

  .base-dialog__actions {
    padding: 16px 24px;
    border-top: 1px solid $color-border;
  }
}

.filters-dialog {
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
}
</style>
